import React from "react"

export default function TypeMonthPicker({ value }) {
  return <div>{value} </div>
}
